import get from 'lodash/get';
import template from 'lodash/template';

const messages = (function() {
  const node = document && document.getElementById('data-messages');
  const html = get(node, 'innerHTML', '{}');
  const messages = JSON.parse(html);
  return messages;
})();


function content(component) {
  return function(key, data) {
    const componentMessages = get(messages, component, {});
    const localized = get(componentMessages, key, '️');
    if (data) {
      return template(localized)(data);
    } else {
      return localized;
    }
  };
}

export default content;
